import { createFeatureSelector, createSelector } from '@ngrx/store'
import { SELECTIONS_FEATURE_TOKEN } from '../../constants/selections.constants'
import { SelectionsState } from '../states/selections.state'
import { selectFavCompetitionId } from '@core/store/selectors/user.selectors'
import { findSeasonAndCompetitionWithFallback } from '@core/utils/season.utils'
import { CallingContext } from '@features/seasons/models/seasons.models'
import { selectSeasonsByContext } from '@features/seasons/state/selectors/seasons.selectors'

export const selectSelectionFeature = createFeatureSelector<SelectionsState>(SELECTIONS_FEATURE_TOKEN)

export const selectSelectionTeams = createSelector(selectSelectionFeature, (state: SelectionsState) => state.teams)
export const selectSelectionTeamsLoader = createSelector(
  selectSelectionFeature,
  (state: SelectionsState) => state.teamsLoading
)

export const selectSelectionPlayers = createSelector(selectSelectionFeature, (state: SelectionsState) => state.players)
export const selectSelectionPlayersLoader = createSelector(
  selectSelectionFeature,
  (state: SelectionsState) => state.playersLoading
)

export const selectSelectionCommonSeason = createSelector(
  selectSelectionFeature,
  (state: SelectionsState) => state.commonSeason
)
export const selectSelectionCommonCompetition = createSelector(
  selectSelectionFeature,
  (state: SelectionsState) => state.commonCompetition
)

export const selectSelectionCommonMatchDays = createSelector(selectSelectionFeature, (state) => state.commonMatchDays)

export const selectSelectionCommonValidMatchDay = createSelector(selectSelectionCommonMatchDays, (matchDays) => {
  if (matchDays?.length) {
    return matchDays.find((matchDay) => matchDay.selected)
  }
})

export const selectSelectionCommonSeasonCompetitionWithFav = (callingContext: CallingContext) =>
  createSelector(
    selectSeasonsByContext(callingContext),
    selectFavCompetitionId,
    selectSelectionCommonSeason,
    selectSelectionCommonCompetition,
    (seasons, favCompetition, season, competition) => ({
      seasons,
      favCompetition,
      season,
      competition
    })
  )

export const selectSelectionSeasonAndCompetition = (callingContext: CallingContext) =>
  createSelector(
    selectSelectionCommonSeasonCompetitionWithFav(callingContext),
    ({ seasons, favCompetition, competition, season }) => {
      if (seasons?.length) {
        return findSeasonAndCompetitionWithFallback(seasons, season?.id, favCompetition, competition?.id)
      }
    }
  )
